var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconMarkdownSolid = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.833 1.667A1.833 1.833 0 0 0 0 3.5v9a1.833 1.833 0 0 0 1.833 1.833h12.334A1.833 1.833 0 0 0 16 12.5v-9a1.833 1.833 0 0 0-1.833-1.833zm1.15 3.026a.67.67 0 0 1 .749.287l1.435 2.295L6.6 4.98a.667.667 0 0 1 1.232.353v5.334a.667.667 0 1 1-1.333 0V7.658l-.768 1.229a.667.667 0 0 1-1.13 0l-.769-1.229v3.009a.667.667 0 1 1-1.333 0V5.333a.67.67 0 0 1 .483-.64M12.167 5a.333.333 0 0 0-.334-.333h-.666a.333.333 0 0 0-.334.333v3h-1a.667.667 0 0 0-.512 1.093l1.667 2a.666.666 0 0 0 1.024 0l1.667-2A.667.667 0 0 0 13.167 8h-1z",
    clipRule: "evenodd"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.833 1.667A1.833 1.833 0 0 0 0 3.5v9a1.833 1.833 0 0 0 1.833 1.833h12.334A1.833 1.833 0 0 0 16 12.5v-9a1.833 1.833 0 0 0-1.833-1.833zm1.15 3.026a.67.67 0 0 1 .749.287l1.435 2.295L6.6 4.98a.667.667 0 0 1 1.232.353v5.334a.667.667 0 1 1-1.333 0V7.658l-.768 1.229a.667.667 0 0 1-1.13 0l-.769-1.229v3.009a.667.667 0 1 1-1.333 0V5.333a.67.67 0 0 1 .483-.64M12.167 5a.333.333 0 0 0-.334-.333h-.666a.333.333 0 0 0-.334.333v3h-1a.667.667 0 0 0-.512 1.093l1.667 2a.666.666 0 0 0 1.024 0l1.667-2A.667.667 0 0 0 13.167 8h-1z",
    clipRule: "evenodd"
  })));
});
export default SvgIconMarkdownSolid;
export const raw = __webpack_public_path__ + "static/media/IconMarkdownSolid.96420d9394602744ef33163be45ff6e6.svg";